/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitPolicy
 */
export interface MonitPolicy {
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    policy_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    broker_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    broker_state?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    broker_country?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    agency_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    agency_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    retail_broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    retail_broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    policyholder_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    policyholder_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    policyholder_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    policyholder_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    it_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    it_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    account_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    account_line_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    org_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    industry_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    industry_gics?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    n_employees?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    pii_phi_count?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    company_revenue?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    aggregate_limit?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    quote_currency?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    locale?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitPolicy
     */
    is_renewal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitPolicy
     */
    is_excess?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitPolicy
     */
    effective_date?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPolicy
     */
    end_date?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    mfa_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    mfa_remote_access?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    mfa_other_priv_accounts?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitPolicy
     */
    insurance_line?: string;
}

/**
 * Check if a given object implements the MonitPolicy interface.
 */
export function instanceOfMonitPolicy(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPolicyFromJSON(json: any): MonitPolicy {
    return MonitPolicyFromJSONTyped(json, false);
}

export function MonitPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPolicy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'policy_number': !exists(json, 'policy_number') ? undefined : json['policy_number'],
        'policy_uuid': !exists(json, 'policy_uuid') ? undefined : json['policy_uuid'],
        'broker_name': !exists(json, 'broker_name') ? undefined : json['broker_name'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'broker_uuid': !exists(json, 'broker_uuid') ? undefined : json['broker_uuid'],
        'broker_state': !exists(json, 'broker_state') ? undefined : json['broker_state'],
        'broker_country': !exists(json, 'broker_country') ? undefined : json['broker_country'],
        'agency_name': !exists(json, 'agency_name') ? undefined : json['agency_name'],
        'agency_uuid': !exists(json, 'agency_uuid') ? undefined : json['agency_uuid'],
        'retail_broker_name': !exists(json, 'retail_broker_name') ? undefined : json['retail_broker_name'],
        'retail_broker_email': !exists(json, 'retail_broker_email') ? undefined : json['retail_broker_email'],
        'policyholder_name': !exists(json, 'policyholder_name') ? undefined : json['policyholder_name'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'policyholder_uuid': !exists(json, 'policyholder_uuid') ? undefined : json['policyholder_uuid'],
        'policyholder_phone': !exists(json, 'policyholder_phone') ? undefined : json['policyholder_phone'],
        'it_email': !exists(json, 'it_email') ? undefined : json['it_email'],
        'it_phone': !exists(json, 'it_phone') ? undefined : json['it_phone'],
        'account_uuid': !exists(json, 'account_uuid') ? undefined : json['account_uuid'],
        'account_line_uuid': !exists(json, 'account_line_uuid') ? undefined : json['account_line_uuid'],
        'org_uuid': !exists(json, 'org_uuid') ? undefined : json['org_uuid'],
        'industry_name': !exists(json, 'industry_name') ? undefined : json['industry_name'],
        'industry_gics': !exists(json, 'industry_gics') ? undefined : json['industry_gics'],
        'n_employees': !exists(json, 'n_employees') ? undefined : json['n_employees'],
        'pii_phi_count': !exists(json, 'pii_phi_count') ? undefined : json['pii_phi_count'],
        'company_revenue': !exists(json, 'company_revenue') ? undefined : json['company_revenue'],
        'aggregate_limit': !exists(json, 'aggregate_limit') ? undefined : json['aggregate_limit'],
        'quote_currency': !exists(json, 'quote_currency') ? undefined : json['quote_currency'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'is_renewal': !exists(json, 'is_renewal') ? undefined : json['is_renewal'],
        'is_excess': !exists(json, 'is_excess') ? undefined : json['is_excess'],
        'effective_date': !exists(json, 'effective_date') ? undefined : json['effective_date'],
        'end_date': !exists(json, 'end_date') ? undefined : json['end_date'],
        'mfa_email': !exists(json, 'mfa_email') ? undefined : json['mfa_email'],
        'mfa_remote_access': !exists(json, 'mfa_remote_access') ? undefined : json['mfa_remote_access'],
        'mfa_other_priv_accounts': !exists(json, 'mfa_other_priv_accounts') ? undefined : json['mfa_other_priv_accounts'],
        'insurance_line': !exists(json, 'insurance_line') ? undefined : json['insurance_line'],
    };
}

export function MonitPolicyToJSON(value?: MonitPolicy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'policy_number': value.policy_number,
        'policy_uuid': value.policy_uuid,
        'broker_name': value.broker_name,
        'broker_email': value.broker_email,
        'broker_uuid': value.broker_uuid,
        'broker_state': value.broker_state,
        'broker_country': value.broker_country,
        'agency_name': value.agency_name,
        'agency_uuid': value.agency_uuid,
        'retail_broker_name': value.retail_broker_name,
        'retail_broker_email': value.retail_broker_email,
        'policyholder_name': value.policyholder_name,
        'policyholder_email': value.policyholder_email,
        'policyholder_uuid': value.policyholder_uuid,
        'policyholder_phone': value.policyholder_phone,
        'it_email': value.it_email,
        'it_phone': value.it_phone,
        'account_uuid': value.account_uuid,
        'account_line_uuid': value.account_line_uuid,
        'org_uuid': value.org_uuid,
        'industry_name': value.industry_name,
        'industry_gics': value.industry_gics,
        'n_employees': value.n_employees,
        'pii_phi_count': value.pii_phi_count,
        'company_revenue': value.company_revenue,
        'aggregate_limit': value.aggregate_limit,
        'quote_currency': value.quote_currency,
        'country': value.country,
        'locale': value.locale,
        'is_renewal': value.is_renewal,
        'is_excess': value.is_excess,
        'effective_date': value.effective_date,
        'end_date': value.end_date,
        'mfa_email': value.mfa_email,
        'mfa_remote_access': value.mfa_remote_access,
        'mfa_other_priv_accounts': value.mfa_other_priv_accounts,
        'insurance_line': value.insurance_line,
    };
}

